import React, { forwardRef, useEffect, useImperativeHandle, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Flex, Spin } from 'antd';
import nodatafound from "../../../../../Assets/Images/Svg/nodatafound.svg";
import VitalConfigurationTable from './configurationTable';
import { fetchRpmVitalsRangeList } from '../../../../../Redux/actions/rpmActions';
import { handleSetPatientRegistrationPayload } from '../../../../../Redux/actions/patientActions';

function VitalConfiguration({ currPageView, handleCancel, handleNext, handlePrevious, isRpmEnabled }, ref) {
    const [checked, setChecked] = useState([]);
    const { isLoading, vitalRangesList } = useSelector((s) => s.rpm);
    const { registrationPayload, selectedEditPatient } = useSelector((s) => s.patients);
    const dispatch = useDispatch();
    const loggedUserObj = sessionStorage.getItem('login_result');
    const loggedUser    = loggedUserObj ? JSON.parse(loggedUserObj) : null;

    const configKeyToVitalCode = {
    systolic: 'BPS',
    diastolic: 'BPD',
    bmi: 'BMI',
    height: 'HI',
    weight: 'WE',
    pulse: 'pulse',
    spo2: 'SPO2',
    temperature: 'TP',
    bloodGlucose: 'BG',
    respiratoryRate: 'RR',
    heartRate: 'HR',
    breathing: 'breathing',
    spirometry: 'spirometry',
};

useEffect(() => {
    const config = selectedEditPatient?.patientVitalsConfigList;

    if (Array.isArray(config)) {
        setChecked(config);
        return;
    }

    if (config && typeof config === 'object') {
        const checkedList = Object.entries(configKeyToVitalCode)
            .filter(([configKey]) => config[configKey] === 1)
            .map(([, vitalCode]) => {
                if (vitalCode === 'HI') return { vitalCode: 'HI', name: 'Height' };
                if (vitalCode === 'WE') return { vitalCode: 'WE', name: 'Weight' };
                return vitalRangesList?.find((v) => v.vitalCode === vitalCode);
            })
            .filter(Boolean);

        setChecked(checkedList);
        return;
    }

    setChecked([]);
}, [selectedEditPatient,vitalRangesList]);

    useEffect(() => {
        dispatch(fetchRpmVitalsRangeList({ status: 1 }));
    }, []);

    // ── Expose collectValues ──────────────────────────────────────────────────

    useImperativeHandle(ref, () => ({
        collectValues: () => {
            if (!checked || checked.length === 0) return;

            const patientVitalsConfigList = {
                bloodGlucose:0, bmi:0, diastolic:0, heartRate:0, height:0, respiratoryRate:0,
                spo2:0, systolic:0, temperature:0, weight:0, breathing:0, pulse:0, spirometry:0,
                createdBy: loggedUser?.user?.userId, modifiedBy: loggedUser?.user?.userId, status: 1,
            };
            if (selectedEditPatient) patientVitalsConfigList.patientId = selectedEditPatient.patientId;

            const vitalCodeMap = { BPS:'systolic', BPD:'diastolic', BMI:'bmi', HI:'height', WE:'weight', pulse:'pulse', SPO2:'spo2', TP:'temperature', BG:'bloodGlucose', RR:'respiratoryRate', HR:'heartRate', breathing:'breathing', spirometry:'spirometry' };

            const patientVitalsRangeList = checked.map((vital) => {
                const key = vitalCodeMap[vital.vitalCode];
                if (key) patientVitalsConfigList[key] = 1;
                const rangeItem = { createdBy: loggedUser?.user?.userId, modifiedBy: loggedUser?.user?.userId, name: vital.name, status: 1, vitalCode: vital.vitalCode };
                if (vital.minimumNormalRange !== undefined) {
                    rangeItem.minimumNormalRange   = vital.minimumNormalRange;
                    rangeItem.maximumNormalRange   = vital.maximumNormalRange;
                    rangeItem.minimumAbnormalRange = vital.minimumAbnormalRange;
                    rangeItem.maximumAbnormalRange = vital.maximumAbnormalRange;
                }
                if (selectedEditPatient) rangeItem.patientCode = selectedEditPatient.patientId;
                return rangeItem;
            });

            dispatch(handleSetPatientRegistrationPayload({ ...registrationPayload, patientVitalsConfigList, patientVitalsRangeList }));
        }
    }));

    const handleVitalCheckUnCheck = (updatedVital) => setChecked(updatedVital);

    return (
        <div className="p-3">
            <div className="flex justify-between items-center py-3 px-6 sticky top-3">
                <h1 className="font-bold text-xl">Configuration - Set Vitals</h1>
            </div>
            <div className={`${!isLoading && vitalRangesList?.length === 0 ? 'w-full flex justify-center items-center' : 'overflow-y-scroll h-[23rem] scrollWidth'}`}>
                {isLoading && vitalRangesList?.length === 0 ? (
                    <div className="flex items-center justify-center mt-[10%]"><Flex align="center" gap="middle"><Spin size="large" tip="Loading" /></Flex></div>
                ) : vitalRangesList?.length === 0 ? (
                    <div className="flex flex-col items-center justify-center"><img src={nodatafound} alt="nodatafound" className="h-min w-min" /><p className="font-medium text-xl">No data found!!</p></div>
                ) : (
                    <VitalConfigurationTable
                        data={vitalRangesList?.filter((i) => i.vitalCode !== 'BG') || []}
                        totalCount={vitalRangesList?.filter((i) => i.vitalCode !== 'BG')?.length}
                        handleVitalCheckUnCheck={handleVitalCheckUnCheck}
                        checked={checked}
                        disabled={isRpmEnabled}
                    />
                )}
            </div>
            <div className='mt-8'>
                <div className="flex md:flex-row text-center flex-col md:items-center items-end justify-end gap-3">
                    <button className={`${currPageView > 1 ? 'block' : 'hidden'} md:min-w-24 w-[3rem] md:w-24 h-8 p-1 custom_filter text-white rounded-lg font-semibold disabled:cursor-not-allowed disabled:opacity-50`} disabled={!isRpmEnabled} onClick={handlePrevious}>Previous</button>
                    <button className="md:min-w-24 w-[3rem] md:w-24 h-8 p-1 bg-white rounded-lg border text-brand-primaryColor border-brand-primaryColor font-semibold custom-button-shadow" onClick={handleCancel}>Cancel</button>
                    <button className="md:min-w-24 w-[3rem] md:w-24 h-8 p-1 custom_filter text-white rounded-lg font-semibold disabled:cursor-not-allowed disabled:opacity-50" disabled={!isRpmEnabled} onClick={handleNext}>Next</button>
                </div>
            </div>
        </div>
    );
}

export default forwardRef(VitalConfiguration);